module.exports = __webpack_public_path__ + "img/dashboard_search.b78e09e7.png";